import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { FileSelector } from "components/base/Form";
import useFileUploader from "hooks/useFileUploader";
import { useContext } from "react";
import { BsTrash } from "react-icons/bs";
import { getOriginalFileName } from "utils/string";
import { CustomerContext } from "./CustomerPage";
import { SALES_DELETE_CUSTOMER_DOCUMENT } from "./graphql";

const DocumentsView = () => {
  const { customer, save } = useContext(CustomerContext);

  function handleUploadedFiles(urls) {
    save({
      variables: {
        id: customer.id,
        newDocumentUris: urls,
      },
    });
  }

  const service = process.env.NODE_ENV === "development" ? "AWS" : "AWS";
  const { isUploading, handleFileUpload } = useFileUploader(
    handleUploadedFiles,
    service,
  );

  const [deleteDocument, deleteDocumentRes] = useMutation(
    SALES_DELETE_CUSTOMER_DOCUMENT,
    {
      onCompleted() {
        Alert("success", "Document deleted successfully.");
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  function tryDeleteDocument(document) {
    if (window.confirm("Are you sure you want to delete this document?")) {
      deleteDocument({
        variables: {
          customerId: customer.id,
          documentId: document.id,
        },
      });
    }
  }

  return (
    <div className="card">
      <h5>Attachments</h5>
      <div className="mt-2">
        <div className="-mx-2">
          <table>
            <tbody>
              {customer.documents.map((i, index) => (
                <tr
                  key={index}
                  className="border-y border-gray-100 dark:border-gray-700"
                >
                  <td className="w-full">
                    <a href={i.uri} target="_blank" rel="noopener noreferrer">
                      {getOriginalFileName(i.uri)}
                    </a>
                  </td>
                  <td>
                    <Button danger onClick={() => tryDeleteDocument(i)}>
                      <BsTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-2">
          <FileSelector
            title="+ Upload Document"
            uploading={isUploading}
            onChange={(e) => {
              const files = [...e.target.files];
              handleFileUpload(files);
              e.target.value = null;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentsView;
